import React, { useState, useEffect } from 'react';
import { OrderCheckingModal } from './Modal';
import { useNavigate } from 'react-router';


const SLIDE_DATA = [
{
  id: 1,
  subtitle: "Logistique & Suivi des Commandes",
  title: "GESTION ET LIVRAISON EFFICACE",
  description: "ORTEGA assure une gestion rigoureuse des commandes, du traitement à la livraison, avec des délais respectés et un suivi transparent à chaque étape.",
  image: "./img/psd-5.png",
  bgColor: "#f5f5f5"
}
,
{
  id: 2,
  subtitle: "Qualité & Confiance",
  title: "PRODUITS FIABLES ET PARTENARIATS DURABLES",
  description: "Nous sélectionnons des produits de qualité et respectons scrupuleusement nos engagements envers nos clients, partenaires et collaborateurs.",
  image: "./img/psd-4.png",
  bgColor: "#f5f5f5"
}
,
{
  id: 3,
  subtitle: "Service Client et Accompagnement",
  title: "UNE ÉQUIPE RÉACTIVE ET DISPONIBLE 7J/7",
  description: "Notre équipe commerciale et technique est à votre écoute pour répondre rapidement à vos besoins, vous conseiller et vous accompagner en continu.",
  image: "./img/psd-6.png",
  bgColor: "#f5f5f5"
}

];



const SLIDE_CONTENT = [
  {
    id: 1,
    title: "Une équipe d’experts à votre service",
    description: "Chez ORTEGA, notre équipe combine expertise technique, professionnalisme et engagement envers nos clients. Nous respectons nos délais et nos engagements, tout en restant ouverts aux partenariats et collaborations pour offrir des solutions sur-mesure et fiables.",
    buttonText: "En savoir plus",
    url: "/apropos",
    bgImage: "./img/psd-1.png"
  },
  {
    id: 2,
    title: "Solutions adaptées à vos besoins",
    description: "Nous déployons des solutions complètes en équipements biomédicaux, informatiques, mobilier et logiciels, en privilégiant la qualité, la sécurité et la satisfaction de nos clients.",
    buttonText: "Découvrir nos services",
    url: "/services",
    bgImage: "./img/img-6.png"
  }
];


export function HeroSlider() 
{
  const navigate = useNavigate();
  const [showForgotModal, setShowForgotModal] = useState(false);

  const setOrder = ()=>{
    const token = localStorage.getItem('token');
    if (token){
      navigate('/commandes-en-cours');
    }
    else{
      setShowForgotModal(true);
    }
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === SLIDE_DATA.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? SLIDE_DATA.length - 1 : prev - 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); 

    return () => clearInterval(interval); 
  }, [currentIndex]); 

  const { subtitle, title, description, image, bgColor } = SLIDE_DATA[currentIndex];


  return (
    <section className="hero-slider position-relative overflow-hidden" style={{ backgroundColor: bgColor }}>
      {/* Bouton Settings */}
      <div className="settings-panel">
        <img  src='../favicon.png'  alt='logo-ortega'  style={{ maxHeight: '60px' }} />
      </div>

      <div className="container-fluid">
        {/* On utilise une clé unique pour forcer le redémarrage de l'animation à chaque slide */}
        <div className="row g-0 align-items-center slider-height" key={currentIndex}>
          
          {/* Section Texte (Gauche) */}
          <div className="col-md-6 ps-md-5 text-container">
            <div className="ps-lg-5 animate-fade-in">
              <h5 className="text-uppercase fw-bold text-muted mb-2 subtitle">
                {subtitle}
              </h5>
              <h1 className="display-4 fw-bold main-title mb-4">
                {title.split('\n').map((line, i) => <React.Fragment key={i}>{line}<br/></React.Fragment>)}
              </h1>
              <p className="description text-muted mb-5">
                {description}
              </p>
              <button className="btn btn-lg rounded-0 btn-outline-green px-4 py-2" onClick={setOrder} >
                Commander maintenant  <i className="bi bi-chevron-right ms-2"></i>
              </button>
            </div>
          </div>

          {/* Section Image (Droite) */}
          <div className="col-md-6 position-relative text-center animate-fade-in-right">
            <img 
              src={image} 
              alt={title} 
              className="img-fluid hero-image"
              style={{ maxHeight: '500px', objectFit: 'contain' }}
            />
          </div>
        </div>
      </div>

      {/* Contrôles du Slider */}
      <button className="slider-control prev" onClick={prevSlide}>
        <i className="bi bi-chevron-left"></i>
      </button>
      <button className="slider-control next" onClick={nextSlide}>
        <i className="bi bi-chevron-right"></i>
      </button>

      {/* Indicateurs (Dots) optionnels */}
      <div className="slider-dots">
        {SLIDE_DATA.map((_, index) => (
          <span 
            key={index} 
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>

      {/* Forgot Password Modal */}
      <OrderCheckingModal show={showForgotModal} onHide={() => setShowForgotModal(false)} />
              
    </section>
  );
}





export function HottestDealsSlider() 
{

  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev === SLIDE_CONTENT.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? SLIDE_CONTENT.length - 1 : prev - 1));
  };

  return (
    <section className="hottest-deals-container container-fluid px-0">
      <div className="row g-0 mt-5">
        
        {/* Colonne de gauche : Contenu Textuel (Le Slider) */}
        <div className="col-md-7 d-flex align-items-center justify-content-center bg-blue-theme p-5 position-relative text-white">
          
          {/* Flèche Gauche */}
          <button className="slider-arrow prev" onClick={prevSlide}>
            <i className="bi bi-chevron-left text-green"></i>
          </button>

          <div className="text-slider-content px-lg-5 animate-fade" key={current}>
            <h1 className="display-6 text-green fw-bold mb-4">{SLIDE_CONTENT[current].title}</h1>
            <p className="lead mb-5 text-green opacity-75">
              {SLIDE_CONTENT[current].description}
            </p>
            <a href={ SLIDE_CONTENT[current].url } className="btn btn-green py-2 px-4 rounded-0">
              {SLIDE_CONTENT[current].buttonText} <i className="bi bi-chevron-right ms-1"></i>
            </a>
          </div>

          {/* Flèche Droite */}
          <button className="slider-arrow next" onClick={nextSlide}>
            <i className="bi bi-chevron-right text-green"></i>
          </button>
        </div>

        {/* Colonne de droite : Image */}
        <div className="col-md-5">
          <div className="h-100 image-bg-wrapper">
            <img 
              src="./img/img-6.jpg" 
              alt="Hottest Deals" 
              className="img-fluid h-100 w-100 object-fit-cover"
            />
          </div>
        </div>

      </div>
    </section>
  );
}